import axios from '../utils/axios';

export const rateUser = async (rating) =>
  await axios.post(`${process.env.REACT_APP_API}/rate-user`, rating);

export const deleteRating = async (ratingId) =>
  await axios.post(`${process.env.REACT_APP_API}/delete-rating/${ratingId}`);
